@if (isOpen() && nexpe(); as config) {
<div class="m-nexpeModal__backdrop" (click)="onBackdropClick($event)">
  <div class="m-nexpeModal">
    <header class="m-nexpeModal__header">
      <h3 class="m-nexpeModal__title">{{ config.nexpe }}</h3>
      <button type="button" class="m-nexpeModal__closeBtn" (click)="onClose()">✕</button>
    </header>

    <div class="m-nexpeModal__content">
      <!-- Nexpe Code Section -->
      <section class="m-nexpeModal__section">
        <h4 class="m-nexpeModal__sectionTitle">{{ 'NEXPE.MODAL.NEXPE_CODE' | translate }}</h4>
        <div class="m-nexpeModal__field">
          <label class="m-nexpeModal__label"
            >{{ 'NEXPE.MODAL.NEXPE_CODE_LABEL' | translate }} *</label
          >
          <input
            type="text"
            class="m-nexpeModal__input"
            [ngClass]="{ 'm-nexpeModal__input--error': showNexpeCodeError() }"
            [value]="config.nexpe"
            (input)="onNexpeChange($any($event.target).value)"
            placeholder="{{ 'NEXPE.MODAL.NEXPE_CODE_PLACEHOLDER' | translate }}"
          />
        </div>
        <div class="m-nexpeModal__field">
          <label class="m-nexpeModal__label">{{ 'NEXPE.MODAL.NAME_LABEL' | translate }} *</label>
          <input
            type="text"
            class="m-nexpeModal__input"
            [value]="config.name ?? ''"
            (input)="onNameChange($any($event.target).value)"
            placeholder="{{ 'NEXPE.MODAL.NAME_PLACEHOLDER' | translate }}"
          />
        </div>
      </section>

      <!-- Features Section -->
      <section class="m-nexpeModal__section">
        <h4 class="m-nexpeModal__sectionTitle">{{ 'NEXPE.MODAL.FEATURES' | translate }}</h4>
        <div class="m-nexpeModal__features">
          <app-feature-checkbox
            [label]="'NEXPE.FEATURES.DECLARATION' | translate"
            [checked]="config.allowedNExpeDeclaration"
            (checkedChange)="onFeatureToggle('allowedNExpeDeclaration')"
          />
          <app-feature-checkbox
            [label]="'NEXPE.FEATURES.DEGRADATION' | translate"
            [checked]="config.allowedNexpeDegradation"
            (checkedChange)="onFeatureToggle('allowedNexpeDegradation')"
          />
          <app-feature-checkbox
            [label]="'NEXPE.FEATURES.TROUBLESHOOTING' | translate"
            [checked]="config.allowedNexpeTroubleshooting"
            (checkedChange)="onFeatureToggle('allowedNexpeTroubleshooting')"
          />
          <app-feature-checkbox
            [label]="'NEXPE.FEATURES.QUALITY' | translate"
            [checked]="config.allowedNexpeQuality"
            (checkedChange)="onFeatureToggle('allowedNexpeQuality')"
          />
          <app-feature-checkbox
            [label]="'NEXPE.FEATURES.RECURRENT_DELAY' | translate"
            [checked]="config.allowedNexpeRecurrentDelay"
            (checkedChange)="onFeatureToggle('allowedNexpeRecurrentDelay')"
          />
          <app-feature-checkbox
            [label]="'NEXPE.FEATURES.ADD_ORDER' | translate"
            [checked]="config.allowedNexpeAddOrder"
            (checkedChange)="onFeatureToggle('allowedNexpeAddOrder')"
          />
          <app-feature-checkbox
            [label]="'NEXPE.FEATURES.MISSING_SUPPORT' | translate"
            [checked]="config.allowedNexpeMissingSupport"
            (checkedChange)="onFeatureToggle('allowedNexpeMissingSupport')"
          />
          <app-feature-checkbox
            [label]="'NEXPE.FEATURES.DELAY' | translate"
            [checked]="config.allowedNexpeDelay"
            (checkedChange)="onFeatureToggle('allowedNexpeDelay')"
          />
          <app-feature-checkbox
            [label]="'NEXPE.FEATURES.EVALUATION' | translate"
            [checked]="config.allowedNExpeEvaluation"
            (checkedChange)="onFeatureToggle('allowedNExpeEvaluation')"
          />
          <app-feature-checkbox
            [label]="'NEXPE.FEATURES.FORCED_EVALUATION' | translate"
            [checked]="config.usersForcedEvaluation"
            (checkedChange)="onFeatureToggle('usersForcedEvaluation')"
          />
        </div>
      </section>

      <!-- Contact Section -->
      <section class="m-nexpeModal__section">
        <h4 class="m-nexpeModal__sectionTitle">{{ 'NEXPE.MODAL.CONTACT' | translate }}</h4>
        <div class="m-nexpeModal__contact">
          <div class="m-nexpeModal__field">
            <label class="m-nexpeModal__label">{{
              'NEXPE.CONTACT.CUSTOMER_SERVICE' | translate
            }}</label>
            <input
              type="text"
              class="m-nexpeModal__input"
              [value]="config.customerService"
              (input)="onContactChange('customerService', $any($event.target).value)"
            />
          </div>
          <div class="m-nexpeModal__field">
            <label class="m-nexpeModal__label">{{ 'NEXPE.CONTACT.FOOD4REST' | translate }}</label>
            <input
              type="url"
              class="m-nexpeModal__input"
              [value]="config.food4rest"
              (input)="onContactChange('food4rest', $any($event.target).value)"
            />
          </div>
        </div>
      </section>

      <!-- CutOff Section -->
      <section class="m-nexpeModal__section">
        <app-cutoff-editor [cutOff]="config.cutOff" (cutOffChange)="onCutOffChange($event)" />
      </section>
    </div>

    <footer class="m-nexpeModal__footer">
      <button type="button" class="m-nexpeModal__btnCancel" (click)="onClose()">
        {{ 'COMMON.CANCEL' | translate }}
      </button>
      <button
        *ngIf="isEditMode()"
        type="button"
        class="m-nexpeModal__btnDelete"
        (click)="onDelete()"
      >
        {{ 'COMMON.DELETE' | translate }}
      </button>
      <button type="button" class="m-nexpeModal__btnSave" (click)="onSave()">
        {{ 'COMMON.SAVE' | translate }}
      </button>
    </footer>
  </div>
</div>
}
